/**
 * Detect fn
 */
export default () => 'Promise' in self
